import { Injectable } from "@angular/core";
import { ConfigData } from "@calaosoft/osapp-common/config/models/ConfigData";
import { take } from "rxjs/operators";
import { EModalSize } from "../../../modal";
import { ModalService } from "../../../modal/services/modal.service";
import { ScriptLoaderService } from "../../../script/script-loader.service";
import { IVisioService } from '../../models/IVisio.service';
import { JitsiModalComponent } from "../components/modal/jitsi-modal.component";

@Injectable({
	providedIn: 'root',
})
export class JitsiService implements IVisioService {

	private static readonly C_LOG_ID: string = "JITSI.S::";

	constructor(
		private readonly iscvModal: ModalService,
		private readonly isvcScript: ScriptLoaderService,
	) {
		if (ConfigData.conversation?.visioApiUrl)
			this.isvcScript.load(`https://${ConfigData.conversation.visioApiUrl}/external_api.js`).subscribe();
		else console.error(`${JitsiService.C_LOG_ID} Url du serveur visio non défini dans l'environnement, impossible d'importer le script d'api.`);
	}

	public showVisioModalAsync(psRoom?: string, psName?: string, psSubjectName?: string): Promise<void> {
		const loComponentParams: { name?: string, room?: string, subjectName?: string } = {
			name: psName,
			room: psRoom,
			subjectName: psSubjectName
		};

		return this.iscvModal.open({
			component: JitsiModalComponent,
			componentProps: loComponentParams
		}, EModalSize.screen)
			.pipe(take(1))
			.toPromise();
	}
}
